import * as React from "react";
import {UserGender} from "@ok/web/models/user/UserGender";
import {buildStubURL, StubType} from "@ok/web/components/base/Avatars/utils/buildStubURL";
import {AvatarCore, IAvatarProps} from "@ok/web/components/base/Avatars/AvatarCore/AvatarCore";

export interface IUserAvatar {
    gender?: UserGender;
    imageUrl?: string;
    name: string;
    href?: string;
}

export interface IUserAvatarProps<U extends IUserAvatar> extends IAvatarProps {
    user: U;
}

export const UserAvatar = (
    {
        user,
        withLink,
        className,
        imageClassName,
        size,
        round = true,
        additionalContent,
        attrs,
        attrsLink
    }: IUserAvatarProps<IUserAvatar>
) => {
    const stubUrl = React.useMemo(() => buildStubURL(
        StubType.USER,
        {
            size,
            gender: user.gender
        }
    ), [size, user.gender]);

    return (
        <AvatarCore size={size}
                    href={user.href}
                    imageUrl={user.imageUrl || stubUrl}
                    alt={user.name}
                    className={className}
                    round={round}
                    withLink={withLink}
                    useResize={true}
                    imageClassName={imageClassName}
                    additionalContent={additionalContent}
                    attrs={attrs}
                    attrsLink={attrsLink}
        />
    );
};
